import { fetchApi } from '../baseApi';
import Provider, { ProviderInformationRequest } from 'src/models/provider';
import { acscriptsAddress } from 'src/appconfig';
// import { acscriptsAddress } from '../../appconfig';

export function getProviderById(registrationId: string) {
    return new Promise((resolve, reject) => {
        fetchApi('api/registrations/' + registrationId, 'GET', undefined).then((files) => {
            resolve(files);
        }).catch(() => {
            reject(new Error('Cannot get provider info!'));
        });
    });
}

export function submitCredential(provider: Provider) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submitcredentials`, 'POST', provider).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot add provider!'));
        });
    });
}

export function submitToVendor(registrationId: string) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submit_to_vendor`, 'POST', registrationId).then((result) => {
            resolve(result);
        }).catch(() => {
            reject(new Error('Cannot submit to vendor!'));
        });
    });
}

export function existNPI(npi: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registration/is_exist_npi?npi=` + npi, 'GET', undefined, acscriptsAddress.Vendor).then((result) => {
            resolve(result);
        }).catch(() => {
            reject(new Error('Cannot check exist NPI!'));
        });
    });
}

export function existDEA(dea: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registration/is_exist_dea?dea=` + dea, 'GET', undefined, acscriptsAddress.Vendor).then((result) => {
            resolve(result);
        }).catch(() => {
            reject(new Error('Cannot check exist DEA!'));
        });
    });
}

export function getFacilitiesByTenantName(tenantName: string) {
    return new Promise((resolve, reject) => {
        fetchApi('api/facilities/tenantName?tenantName=' + tenantName, 'GET', undefined, acscriptsAddress.Vendor).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot get facilities by tenant name!'));
        });
    });
}

// New Step01
export function submitProviderInformation(request: ProviderInformationRequest) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submit_provider_information`, 'POST', request).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot submit provider information!'));
        });
    });
}



// WEBPACK FOOTER //
// ./src/api/provider/index.ts